import { MatchFactory } from './MatchFactory';
import { RoundFactory } from './RoundFactory';
import { Required } from 'utility-types';
import {
  MatchAggregated,
  Round,
} from '../../../types/firestore/Game/Tournament/Bracket';
import { LinkedListUtil } from './LinkedListUtil';
import { v4 as uuidv4 } from 'uuid';

export abstract class EliminationTournament {
  protected constructor(
    protected readonly matchFactory: MatchFactory = new MatchFactory(),
    protected readonly roundFactory: RoundFactory = new RoundFactory(),
  ) {}

  public static tieRounds = (
    rounds: Required<Round, 'matches'>[],
  ): Required<Round, 'matches'>[] => {
    const firstRound = { ...rounds[0], next: uuidv4() };
    const newRounds = [firstRound, ...rounds.slice(1, rounds.length)];
    return newRounds.map((round, i) => {
      if (i !== newRounds.length - 1) {
        LinkedListUtil.tie(round, newRounds[i + 1]);
      }
      return round;
    });
  };

  protected get initialFactory(): MatchFactory {
    return new MatchFactory((team1, team2) => {
      const isBypass = (!team1 && !!team2) || (!!team1 && !team2);
      return isBypass
        ? {
            winner: team1 || team2,
            ...this.matchFactory.settings(),
          }
        : {
            ...this.matchFactory.settings(),
          };
    });
  }

  protected nextRound(
    round: Required<Round, 'matches'>,
    roundIndex?: number,
  ): Required<Round, 'matches'> {
    const matchesNext = this.nextMatches(round.matches, roundIndex);
    return this.roundFactory.build(matchesNext);
  }

  protected germinateBracket(
    initialRound: Required<Round, 'matches'>,
    roundCount: number,
  ) {
    const rounds = [initialRound];
    for (let i = 0; i < roundCount - 1; i++) {
      rounds.push(this.nextRound(rounds[Number(i)], i));
    }
    return EliminationTournament.tieRounds(rounds);
  }

  protected abstract nextMatches(
    matches: MatchAggregated[],
    roundIndex?: number,
  ): MatchAggregated[];
}
